export default {
    login: {
        first: 'Wir erstellen',
        second: 'Sensorlösungen für Sie.',
        third: 'Unser einfaches, aber intelligentes Design bietet Ihnen die Tools, um Echtzeitdaten in sofort verbesserte Geschäftsleistung umzuwandeln.',
        first_flower: 'wir geben den oflichen raum farben mit unsere langlebige bluten konzepten.',
        second_flower: '',
        third_flower: 'Wir sorgen für blühende öffentliche Grünflächen und große Gärten in ganz Europa. Dazu liefern und pflanzen wir Blumenzwiebeln, Wildblumen und Stauden.',
        desc: 'Melden Sie sich an, indem Sie unten Informationen eingeben',
        username: 'Email',
        password: 'Passwort',
        successful: 'Anmeldung erfolgreich',
        logout: 'Ausloggen',
        log: 'Anmeldung',
        in: '',
    },
    dashboard: {
        title: 'Instrumententafel',
        search: 'Suchen',
        no_lora_id: 'Keine LoRa-ID',
        dealer_view: 'Dealer view',
        nav: {
            type: 'Art',
            location: 'Ort',
            batch: 'Kalibrierung',
            remark: 'Anmerkung',
            lqi: 'Verbindungslink',
            lqi_hover: 'Verbindungsqualitätsindikator',
            unit: 'Einheit',
            last_event: 'Letzte Veranstaltung',
            l_update: 'Letzte Daten',
            timing: 'Dynamisches Timing',
            sensing: 'Erweiterte Einstellungen',
            notification: 'Benachrichtigung',
            customer: 'Kunde',
            favourite: 'Lieblings',
        },
        bulk_setup: {
            substrate_properties: 'Substrateigenschaften',
            frame_selection: 'Rahmenauswahl',
            critical_value: 'Benachrichtigungsschwellen',
            payload_error: 'Das Nutzdatenformat ausgewählter Geräte ist nicht identisch',
            hundred_tx_power: 'Berechnet für 100 % Sendeleistung.',
            version_error: 'Lebensdauerberechnung nur für Geräte mit identischen Versionen verfügbar.',
            sa_error: 'Die Lebensdauerberechnung ist nur für Geräte ohne Selbsterkennung verfügbar (bitte überprüfen Sie die Gerätedetailseite).',
            sa_version_error: 'Die Berechnung der Lebensdauer ist nur für Geräte mit identischen Versionen ohne Selbsterkennung verfügbar (Informationen zur Gerätelebensdauer finden Sie auf der Gerätedetailseite).',
            version_identical_sa_error: 'Profilauswahl ist nur für Geräte mit derselben Version verfügbar.',
            batch_type_error: 'Art der Tentakelkalibrierung ist nicht identisch (Eigenschaften deaktiviert)',
            batch_missing_error: 'Eine oder mehrere Tentakelkalibrierungen sind nicht eingestellt (Eigenschaften deaktiviert)',
            batch_all_error: 'Um fortzufahren, stellen Sie bitte alle Eigenschaften ein',
            affected: 'Änderung auf {count} Geräte angewendet',
            identical_version_error: 'Bitte wählen Sie Geräte mit identischen Versionen für die Massenbearbeitung aus (Änderung des Messintervalls nicht möglich).',
            measurement_interval_cant: 'Änderung des Messintervalls nicht verfügbar.',
            measurement_sets_cant: 'Akkumulation, Downlink-Intervall und Downlink-Wiederholungsversuche sind nicht verfügbar.',
            sa_active_error: 'Bitte wählen Sie Geräte ohne aktives Self Awareness-Profil aus, um „Akkumulation“, „Downlink-Intervall“ und „Downlink-Wiederholungen“ zu ändern.',
            sa_mixed_error: 'Bitte wählen Sie zum Bearbeiten der Rahmenauswahl nur Geräte mit oder ohne aktivem Selbstbewusstseinsprofil aus (Kombination nicht möglich).',
            expert_mode: '*Expertenmodus aktiviert!! Alle Optionen werden angezeigt, während die Selbstwahrnehmung aktiviert ist.',
            data_auto_scaling: '*Daten-Autoskalierung aktiviert! Sensor verwendet Kalibrierungsmaßstab-Koeffizienten. ',
        },
        remark: {
            double_click: 'Doppelklicken Sie',
            to_add: 'um einen Mehrwert zu erzielen',
            history: 'Bemerkung Geschichte',
            show_history: 'Bemerkungsverlauf anzeigen',
        },
    },
    map: {
        calculated: 'Berechneter Standort',
        manual: 'Manuelle Platzierung',
    },
    detail: {
        new_calib_point: 'Neuen Kalibrierungspunkt hinzufügen',
        remove_calib_point: 'Kalibrierpunkt entfernen',
        raw_value: 'Rohwert',
        calibrate_min: 'Kalibrieren min.',
        calibrate_max: 'Kalibrieren Sie max.',
        apply_calib: 'Wenden Sie die Kalibrierung auf die Eigenschaften an',
        reset_minmax: 'Min und Max-Werte zurücksetzen',
        reset_calib: 'Auf zugewiesene Kalibrierung zurücksetzen',
        select_props: 'Bitte wählen Sie die zu kalibrierenden Eigenschaften aus',
        save_props: 'In ausgewählten Eigenschaften speichern',
        percent: 'VWG',
        batch: 'Kalibrierung',
        selected_batch: 'Ausgewählte Kalibrierung',
        raw: 'Raw',
        warning: 'Warnung',
        warning_vwc: 'Der Wert für VWG oder das RAW-Äquivalent ist ungültig. Bitte korrigieren Sie die Werte so, dass sie mehr als minimal, kleiner als maximal oder ein anderer nicht vorhandener Wert sind.',
        measured_min: 'Gemessenes Minimum',
        measured_max: 'Gemessene Maximal',
        lqi: 'Verbindungsqualität',
        lqi_calculated: 'Berechnet mit Basisstationen.',
        map: 'Sensorposition',
        sensor_setting: 'Sensoreinstellungen',
        etentacles_setting: 'iTentacles-Einstellungen',
        min_value: 'Min. Wert',
        last_value: 'Letzter Wert',
        max_value: 'Maximaler Wert',
        select_data: 'Daten auswählen',
        missing: 'Keine Daten verfügbar',
        moisture_calibration: 'VWG-Kalibrierung',
        warning_batch_calibration: 'Warnung! Sie aktualisieren die zugewiesene Kalibrierung!',
        warning_device_calibration2: 'Warnung! Um die Kalibrierung auf Eigenschaften anzuwenden, klicken Sie auf "Wenden Sie die Kalibrierung auf die Eigenschaften an"',
        device_only_label: 'Nur für das Gerät kalibrieren',
        payload_format: 'Messnutzlastrahmen (Gerät)',
        payload_format_change: 'Messnutzlastrahmen ändern',
        payload_format_not_set: 'Noch nicht aktualisiert',
        payload_format_changed: 'Letzte Bearbeitung',
        payload_format_updated: 'Letzte Aktualisierung',
        format: 'Rahmen',
        set_format: 'Rahmen einstellen',

        dynamic_sensing: 'Erweiterte Einstellungen',
        measurement_frame: 'Messrahmen',
        none: 'Keiner',
        moisture: 'Feuchtigkeit',
        temperature: 'Temperatur',
        light: 'Licht',
        measurement_sets: 'Akkumulierte Messsätze',
        measurement_interval: 'Messintervall',
        sigfox_frames_transmitted: 'Übertragene Sigfox-Frames',
        lora_connections: 'Lora-Verbindung/Netzwerk',
        downlik_period: 'Downlink-Zeitraum',
        downlink_retries: 'Downlink-Wiederholungen',
        transmitting_power: 'Sendeleistung',
        message_interval: 'Nachrichtenintervall',
        sigfox_device_lifespan: 'SigFox-Gerätelebensdauer',
        device_lifespan: 'Gerätelebensdauer',
        device_loralifespan: 'LoRa Gerätelebensdauer',
        downlink_max: 'Max efficiency',
        once_per_four: 'Einmal pro 4 Tage',
        once_per_two: 'Einmal pro 2 Tage',
        once_per_day: 'Einmal am Tag',
        twice_per_day: 'Zweimal am Tag',
        set_dynamic_sensing: 'Erweiterte Einstellungen festlegen',
        sa_title: 'Selbstbewusstsein',
        sa_select_profile: 'Aktives Profil',
        sa_enable_profile: 'Profil festlegen',
        sa_hover: 'Basierend auf dem Profil werden Geräteeinstellungen basierend auf dem Kommunikations-/Verbindungsstatus geändert',
        sa_automatic_mode: '*Von der Selbstwahrnehmung verwaltete Optionen werden ausgeblendet',
    },
    lqi: {
        Excellent: 'Ausgezeichnet',
        Good: 'Gut',
        Average: 'Durchschnittlich',
        Limit: 'Begrenzt'
    },
    server_status: {
        title: 'Server Status',
    },
    privacy: {
        title: 'Datenschutz-Bestimmungen',
    },
    sigfox_coverage: {
        title: 'Signalabdeckung',
        coverage_error: 'Coverage Service-Fehler',
        unstable: 'Es gibt keine Abdeckung und das Gerät wird möglicherweise nicht synchronisiert.',
        works_underground: 'Die Verbindung ist stark und das Gerät sollte unterirdisch oder tief in Innenräumen funktionieren.',
        possible_underground: 'Die Verbindung ist stark genug, um unterirdisch oder tief drinnen arbeiten zu können.',
        works_indoor: 'Die Verbindung ist stabil und das Gerät sollte in Innenräumen funktionieren (möglicherweise nicht im Untergrund).',
        possible_indoor: 'Die Verbindung ist stabil genug für die Möglichkeit, in Innenräumen zu arbeiten. (funktioniert möglicherweise nicht im Untergrund).',
        works_open: 'Die Verbindung ist möglicherweise nicht stabil und das Gerät sollte auf offenem Feld funktionieren.',
        possible_open: 'Das Gerät hat eine Verbindung und es besteht die Möglichkeit, dass das Gerät auf offenem Feld funktioniert.',
        coverage_env: "Geräteplatzierung",
        coverage_env_greenhouse: "Gewächshaus",
        coverage_env_indoors: "Drinnen",
        coverage_env_outdoors: "Draußen",
    },
    payload: {
        title: 'Soil 3XS Nutzlast',
    },
    export: {
        limit: 'Wählen Sie die letzten x-Werte aus ausgewählten Tentakeln aus',
        info: {
            first: 'Export',
            second: 'ausgewählt',
            rest: 'Wählen Sie zunächst einige Einheiten aus der Tabelle aus',
        },
        tabs: {
            date_range: 'Datumsbereich',
            limit_values: 'Grenzwerte',
        },
    },
    contact_us: {
        title: 'Kontaktiere uns',
        subj: 'Gegenstand',
        mess: 'Botschaft',
    },
    tooltips: {
        customer: 'Anzeigen von Geräten, die diesem Kunden zugeordnet sind',
        logout: 'Ausloggen',
        total_units: 'Gesamteinheiten',
        unit_name: 'Einheitenname',
        excel: 'In Excel-Datei exportieren',
        csv: 'In CSV exportieren',
        search: 'oder drücken Sie',
        tentacle_missing: 'Wähle mindestens einen Tentakel',
        network: 'Ändern Sie die angezeigte externe Netzwerk-ID',
    },
    buttons: {
        ok: 'Ok',
        login: 'Anmeldung',
        detail: 'Detail',
        apply: 'Änderungen übernehmen',
        apply_range: 'Bereich anwenden',
        bulk: 'Bulk-Setup',
        bulkdetail: 'Massendetail',
        cancel: 'Stornieren',
        send: 'Senden',
        export: 'Export',
        delete_range: 'Bereich löschen',
        next: 'Nächster',
        previous: 'Zurück',
        save: 'Sparen',
    },
    metrics: {
        moisture: 'VWG',
        moisture_top: 'Oberer VWC',
        moisture_middle: 'Mittlerer VWC',
        moisture_bottom: 'Unterer VWC',
        light: 'Licht',
        temperature: 'Temperatur',
        battery: 'Batterie',
        pH: 'pH',
        ph: 'pH',
        pump_mode: 'Pumpe läuft',
        pressure: 'Druck',
        gyroscope: 'Vibrationen',
        events: 'Veranstaltungen',
        currents: 'Phasenstrom',
        angles: 'Phasenwinkel',
        over_vibration_stop: 'Überschwingungsstopp',
    },
    timing: {
        t1: '15 Minuten',
        t2: '30 Minuten',
        t3: '1 Stunde',
        t4: '2 std',
        t5: '8 std',
        t6: 'Ausschalten',
    },
    interval: {
        day: 'für einen tag',
        week: 'für eine Woche',
        month: 'für Monat',
        year: 'für Jahr',
    },
    notifications: {
        sms: 'SMS',
        email: 'E-Mail',
        push: 'Push-Benachrichtigung',
    },
    sensing: {
        sens1: 'Current Soil 3XT-4',
        sens2: 'Original 2x per hour',
        sens3: 'Moisture 4x per hour',
        sens4: 'Moisture 3x per 45 min',
        sens5: 'Moisture/Temp 2x per 30 min',
        sens6: 'Moisture/Temp/Light 2x per 30 min',
    },
    info: {
        loading_data: 'Lade Daten'
    },
    eventChart: {
        networkGatewaysCreated: "Bereitstellung für Netzwerk",
        networkGatewayActive: "Gerät EIN",
        networkGatewayRemoved: "Wird aus dem Netzwerk entfernt",
        fportSettingsChange: "Änderung der erweiterten LoRa-Einstellungen",
        activeGatewayChange: "Netzwerk geändert",
        networkChangeRequest: "Netzwerkänderung",
        networkDownlinkLimit: "Downlink-Limit",
        fportSettingsChange101Message: "Aggregierte Geräteeinstellungen aktualisiert",
        fportSettingsChange102Message: "Geräte-LoRa-Datenraten aktualisiert",
        fportSettingsChange103Message: "Geräte-Neuübertragungseinstellungen aktualisiert",
        activeGatewayChangeMessage: "Gerätenetzwerk {previous} wurde in {active} geändert",
        networkChangeRequestMessage: "Gerätenetzwerk {previous} wird zu {new} geändert",
        networkDownlinkLimitMessage: 'Das Limit für LoRa-Downlinks wurde erreicht. Der nächste verfügbare Downlink (Einstellungen) ist morgen.',
        networkGatewaysCreatedMessage: "Gerät wurde für Netzwerke [{networks}] bereitgestellt",
        networkGatewayActiveMessage: 'Gerät hat die ersten Daten im {network}-Netzwerk gesendet',
        networkGatewayRemovedMessage: "Gerät wurde aus dem Netzwerk {network} entfernt",
        sequenceMessage: 'Erwartete Sequenznummer war {previous} kam {actual}',
        ensBackupMessage: 'ENS hat das Netzwerk auf {network} gewechselt, weil das Netzwerk nicht verfügbar ist.',
        ensSequenceMessage: 'ENS hat das Netzwerk auf {network} gewechselt, weil eine Nachricht fehlt.',
        ansRegularMessage: 'ANS hat das Netzwerk auf {network} gewechselt, weil die Netzwerkverbindung schlecht ist.',
        ansExecutionMessage: 'ANS/ENS hat das {network}-Netzwerk ausgewählt.',
        lqiMessage: 'Lqi ist niedrig für vergangene {badCount} Nachrichten. Zuletzt war "{lqi}"',
        invalidMessage: 'Gerät sendet falsche Daten',
        ackMessage: 'Vom Gerät erwartetes Update war {expectedAt}',
        sequence: 'Fehlende Sequenznummer',
        lqi: 'Niedriger LQI',
        power: 'Änderung der Sendeleistung',
        settings: 'Einstellungen geändert',
        invalid: 'Ungültige Daten',
        pendingChange: 'Ausstehende Änderung',
        pendingChangeMessage: 'Gerät muss geänderte Einstellungen noch anwenden.',
        verifiedChange: 'Verifizierte Änderung',
        verifiedChangeMessage: 'Geräteeinstellungen durch Downlink verifiziert geändert.',
        ack: 'Einstellungen nicht übernommen',
        info: 'Die Info',
        warning: 'Warnung',
        error: 'Fehler',
        latestEvent: 'Letztes Ereignis',
        sigfoxDeleted: 'Cloud-AUS-Zustand',
        sigfoxCreated: 'Cloud-EIN-Zustand',
        deviceOn: 'Gerät EIN',
        sigfoxDeletedMessage: 'Cloud-Gerät ist auf AUS-Zustand eingestellt',
        sigfoxCreatedMessage: 'Cloud-Gerät ist auf EIN-Zustand eingestellt',
        deviceOnMessage: 'Gerät hat erste Daten im SigFox-Netzwerk gesendet',
        events: 'Veranstaltungen',
        message: 'Nachricht',
        default: 'Standard',
        changedBy: 'Geändert von {name}',
        customer: 'Kundenwechsel',
        calibration: 'Kalibrierung geändert',
        calibrationMessage: 'Die Kalibrierungseinstellungen ändern sich.',
        customerMessage: 'Der Kunde wurde in {name} geändert.',
        baseCalibrationMessage: 'Die Basiskalibrierung wurde in {calibration} geändert.',
        propertiesCalibrationMessage: 'Die Kalibrierung wurde in {properties} geändert.',
        powerMessage: 'Die Broadcast-Einstellungen des Geräts wurden geändert.',
        transmittingMessage: 'Die Sendeleistung wurde von {previous} auf {actual} geändert.',
        periodMessage: 'Der Zeitraum wurde von "{previous}" in "{actual}" geändert.',
        networkTypesMessage: 'Netzwerktyp wurde von „{previous}“ in „{actual}“ geändert.',
        sfFramesMessage: 'Sigfox-Übertragungsframes wurden von „{previous}“ in „{actual}“ geändert.',
        spanMessage: 'Die Messintervallspanne hat sich von {previous} auf {actual} Minuten geändert.',
        retriesMessage: 'Die Anzahl der Wiederholungsversuche wurde von {previous} auf {actual} geändert.',
        settingsMessage: 'Geräteeinstellungen geändert.',
        frameMessage: 'Der Frame wurde von "{previous}" in "{actual}" geändert.',
        intervalMessage: 'Das Intervall hat sich von {previous} auf {actual} Minuten geändert.',
        accumulationMessage: 'Die Anhäufung hat sich von {previous} zu {actual} Nachrichten geändert.',
        thresholdMessage: 'Das Gerät hat kritische Werte gemessen.',
        criticalMessage: '{sensor} kritischer Sensorwert von {value}{unit} erreicht (Schwellenwert {threshold}{unit} festgelegt).',
        threshold: 'Kritischer Wert',
        attentionMessage: 'Vom Gerät gemessene Aufmerksamkeitswerte.',
        notificationMessage: '{sensor} Sensoraufmerksamkeitswert von {value}{unit} erreicht (Schwellenwert {threshold}{unit} festgelegt).',
        attention: 'Aufmerksamkeitswert',
        selfAwarenessChange: 'Selbstbewusstsein',
        selfAwarenessChangeTooltipSequence: 'Selbstbewusstseinseinstellungen angewendet.',
        selfAwarenessChangeTooltipLqi: 'Selbstbewusstseinseinstellungen angewendet.',
        selfAwarenessChangeTooltipStandby: 'Selbstbewusstseinseinstellungen ignoriert.',
        selfAwarenessChangeTooltipVwc: 'Selbstbewusstseinseinstellungen ignoriert.',
        selfAwarenessChangeMessageSequence: 'Fehlende Nachricht erkannt und Selbsterkennungseinstellungen für das Profil {state} {profile} ausgeführt.',
        selfAwarenessChangeMessageLqi: 'Entspricht {number} {lqi} LQI und führt Self Awareness im Profil {state} {profile} durch.',
        selfAwarenessChangeMessageStandby: 'Die Ausführung der Selbsterkennung wurde übersprungen, da sich das Gerät im Standby-Modus befindet.',
        selfAwarenessChangeMessageVwc: 'Die Ausführung der Selbsterkenntnis wurde übersprungen, da das Gerät einen VWC unter 5 % gemessen hat.'
    },
    transmittingPower: {
        15: "125%",
        14: "100%",
        13: "80%",
        12: "65%",
        11: "50%",
        10: "40%",
        9: "33%",
        8: "25%",
        7: "20%"
    },
    downlinkPeriods: {
        0: {
            25: "Einmal pro 4 Tage",
            5: "Einmal pro 2 Tage"
        },
        1: "Einmal am Tag",
        2: "Zweimal am Tag"
    },
    networkTypes: {
        1: "Nur Sigfox",
        2: "Nur LoRa",
        3: "Priorität zuletzt verbunden",
        4: "Priorität SigFox",
        5: "Priorität LoRa"
    },
    sfFrames: {
        1: "Ein Frame",
        2: "Drei Frame"
    },
    sensors: {
        Moist: 'VWC',
        light: 'Licht',
        temp: 'Temperatur',
        battery: 'Batterie'
    },
    slider: {
        header: {
            attention: 'Aufmerksamkeit',
            critical: 'Kritisch'
        }
    },
    header: {
        custom_name: "Benutzerdefinierter Name",
        generic_name: "Generischer Name",
        network_sigfox: "Sigfox",
        network_lora: "LoRa",
    },
    network: {
        active_network: 'Aktives Netzwerk',
        null: 'Unbekannt',
        sigfox: 'Sigfox',
        helium: 'Helium',
        skynet: 'SkyNet',
    }
};
